export default __webpack_public_path__ + "static/media/academia_1.f9633d74.jpg";